// /api/temperature.js

const PRAGUE_COORDS = {
    lat: 50.0755,
    lon: 14.4378
};

export const RealTemperatureService = {
    fetchTemperature: async function() {
        try {
            const url = `https://api.open-meteo.com/v1/forecast?latitude=${PRAGUE_COORDS.lat}&longitude=${PRAGUE_COORDS.lon}&current_weather=true`;
            
            const response = await fetch(url);
            if (!response.ok) throw new Error('Network response was not ok');

            
            const data = await response.json();
            return data.current_weather.temperature;
        } catch (error) {
            console.warn("Temperature API Error:", error);
            return null;
        }
    }
};